import { HomeOutlined, RightOutlined } from '@ant-design/icons';
import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getBreadcrumbs, ROUTES } from '@/constants/routes';
import styles from './AppBreadcrumb.module.scss';

export function AppBreadcrumb() {
  const { pathname } = useLocation();

  const crumbs = useMemo(() => {
    const items = getBreadcrumbs(pathname);

    if (pathname === ROUTES.DASHBOARD) {
      return items;
    }

    if (items[0]?.path === ROUTES.DASHBOARD) {
      return items;
    }

    return [{ label: 'Dashboard', path: ROUTES.DASHBOARD }, ...items];
  }, [pathname]);

  return (
    <nav className={styles.nav} aria-label="Breadcrumb">
      <ol className={styles.list}>
        {crumbs.map((item, index) => {
          const isLast = index === crumbs.length - 1;
          const isHome = item.path === ROUTES.DASHBOARD;
          const isLink = Boolean(item.path && !isLast);

          return (
            <li key={`${item.label}-${index}`} className={styles.item}>
              {index > 0 ? <RightOutlined className={styles.separator} aria-hidden /> : null}

              {isLink && item.path ? (
                <Link to={item.path} className={styles.link}>
                  {isHome ? <HomeOutlined className={styles.homeIcon} /> : null}
                  <span>{item.label}</span>
                </Link>
              ) : (
                <span
                  className={isLast ? styles.current : styles.segment}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
